import { useSceneStore } from '@/stores/scene';
import { useStageStore } from '@/stores/stage';

export default class Screenshot {
    constructor(context, cameraSettings) {
        this.context = context;
        this.cameraSettings = cameraSettings;
        this.sceneStore = useSceneStore();
        this.stageStore = useStageStore();
    }

    export(mode, fileName, numberOfShots = 3, backgroundColor = '') {      
        const lastCameraPosition = { ...this.context.camera.position };
        this.#setCameraPosition();

        const screenshots = this.#captureScreenshots(numberOfShots, backgroundColor);
        this.#restoreCameraPosition(lastCameraPosition);
        this.#setBackgroundColor(this.sceneStore.backgroundColor);

        if (!['get', 'download'].includes(mode)) {
            throw new Error('Invalid export mode');
        }

        if (mode === 'get') {
            return screenshots;
        }

        if (mode === 'download') {
            screenshots.forEach((screenshot, index) => this.#downloadFiles(screenshot, fileName, index));
        }
    }

    #setCameraPosition() {
        this.context.camera.position.set(
            this.cameraSettings.position.x,
            this.cameraSettings.position.y,
            this.cameraSettings.position.z
        );
        this.context.camera.lookAt(
            this.cameraSettings.target.x,
            this.cameraSettings.target.y,
            this.cameraSettings.target.z
        );
    }

    #captureScreenshots(numberOfShots, backgroundColor) {
        const screenshots = [];
        const angleStep = (2 * Math.PI) / numberOfShots;

        this.#toggleBase(false);

        for (let i = 0; i < numberOfShots; i++) {
            const angle = i * angleStep - angleStep;

            this.#rotateObjects(angle);
            this.#setBackgroundColor(backgroundColor);
            this.context.renderer.render(this.context.scene, this.context.camera);
            
            const imageData = this.context.renderer.domElement.toDataURL();
            screenshots.push(imageData);
        }
        this.#rotateObjects(0);
        this.#toggleBase(true);

        return screenshots;
    }

    #rotateObjects(angle) {
        this.context.scene.traverse((object) => {
            if (object.name === 'Product' || object.name === 'Texture') {
                object.rotation.y = angle;
            }
        });
    }

    #setBackgroundColor(backgroundColor) {
        const alpha = backgroundColor ? 1 : 0;
        this.context.renderer.alpha = true;
        this.context.renderer.setClearColor(backgroundColor, alpha);
    }

    #downloadFiles(imageData, fileName, count) {
        const link = document.createElement('a');
        link.href = imageData;
        link.download = `${fileName}_${count}.png`;
        link.click();
    }

    #restoreCameraPosition(lastCameraPosition) {
        this.context.camera.position.set(
            lastCameraPosition.x, 
            lastCameraPosition.y, 
            lastCameraPosition.z
        );
    }

    #toggleBase(isVisible) {
        this.context.scene.traverse((object) => {
            if (object.type === 'GridHelper' || object.name === 'Base') {
                object.visible = isVisible;
            }
        });
    }
}
